import React from 'react';
import {useGlobalStateVariable, Variables} from '../providers/global-state';
import {ActivityBarTabs, LayoutType} from '../components/layout/page-layout/layout-typings';
import {usePreselectedTab} from '../components/layout/page-layout/use-preselected-tab';

interface Props {
    activityTabStorageKey: keyof Variables;
    defaultActivityBarTab: ActivityBarTabs;
    layout: LayoutType;
}

export function useSidebarTabs(props: Props) {
    const {activityTabStorageKey, defaultActivityBarTab, layout} = props;

    const {getPreselectedTabFromUrl, clearPreselectedTab} = usePreselectedTab();
    const preselectedTab = getPreselectedTabFromUrl(layout);

    const [activityBarTab, setActivityBarTab] = useGlobalStateVariable(
        activityTabStorageKey,
        defaultActivityBarTab
    );

    React.useEffect(() => {
        if (preselectedTab) {
            setActivityBarTab(preselectedTab);
            clearPreselectedTab();
        }
    }, [preselectedTab, setActivityBarTab, clearPreselectedTab]);

    return {
        activityBarTab: preselectedTab || (activityBarTab as ActivityBarTabs),
        setActivityBarTab
    };
}
